var map = {
	"./site.de.json": [
		6129,
		[
			129
		]
	],
	"./site.fr.json": [
		1334,
		[
			334
		]
	],
	"./site.it.json": [
		79,
		[
			79
		]
	],
	"./site.pt.json": [
		6586,
		[
			586
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2977;
module.exports = webpackAsyncContext;